import React from 'react'
import styled from 'styled-components'

const HeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: var(--lh);
  margin-bottom: var(--lh);
`

const PageHeader = ({ children }) => (
  <HeaderContainer>
    <h1>{children}</h1>
  </HeaderContainer>
)

export default PageHeader



// WEBPACK FOOTER //
// ./src/components/PageHeader.js